// Uretim: REACT_APP_API ile derlenir; yerelde localhost'a duser.
export const baseURL = process.env.REACT_APP_API || "http://localhost:5000/";
export const secretKey = process.env.REACT_APP_KEY || "badu_dev_secret_key";
export const projectName = "AYVO";
